import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiDroplet, FiHeart, FiCpu, FiCheck, FiArrowRight } from 'react-icons/fi';
import './SustainabilitySection.css';

const detailSections = [
  {
    key: 'materials',
    icon: FiDroplet,
    image: 'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?auto=format&fit=crop&w=1200&q=80',
    alt: 'Sürdürülebilir malzemelerin depolandığı modern bir tesis.'
  },
  {
    key: 'health',
    icon: FiHeart,
    image: 'https://plus.unsplash.com/premium_photo-1661963493695-e35f0ef5c920?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1841',
    alt: 'Geniş pencereler ve bitkilerle doğal ışık alan sağlıklı bir iç mekân tasarımı.'
  },
  {
    key: 'technology',
    icon: FiCpu,
    image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80',
    alt: 'İnşaat teknolojilerinin kullanıldığı yenilikçi proje toplantısı.'
  }
];

const SustainabilitySection = () => {
  const { t } = useTranslation();

  return (
    <section id="sustainability" className="sustainability-home section-padding">
      <div className="container">
        <motion.div
          className="sustainability-home__intro text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <span className="sustainability-home__badge">{t('sustainability.futureOriented')}</span>
          <h2>{t('sustainability.title')}</h2>
          <p>{t('sustainability.subtitle')}</p>
        </motion.div>

        <div className="sustainability-home__features">
          {t('sustainability.features', { returnObjects: true }).map((feature, index) => (
            <motion.div
              key={index}
              className="sustainability-home__feature"
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <FiCheck />
              <span>{feature}</span>
            </motion.div>
          ))}
        </div>

        <div className="sustainability-home__details">
          {detailSections.map((section, index) => (
            <motion.article
              key={section.key}
              className={`sustainability-home__detail ${index % 2 === 1 ? 'reverse' : ''}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <div className="detail-media">
                <img src={section.image} alt={section.alt} />
                <span className="detail-icon">
                  <section.icon />
                </span>
              </div>
              <div className="detail-content">
                <span className="detail-index">0{index + 1}</span>
                <h3>{t(`sustainability.sections.${section.key}.title`)}</h3>
                <p>{t(`sustainability.sections.${section.key}.description`)}</p>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div
          className="sustainability-home__cta"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3>{t('sustainability.ctaTitle')}</h3>
          <p>{t('sustainability.ctaSubtitle')}</p>
          <Link to="/contact" className="sustainability-home__cta-link">
            {t('sustainability.ctaButton')}
            <FiArrowRight />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default SustainabilitySection;
